import { BasePageType } from "../base";
import EventsPage from "./EventsPage";

// Sample events data for testing
const today = new Date();
const defaultEvents = [
	{
		id: 1,
		title: "Monthly Book Club Meeting: 'The Midnight Library'",
		description: "Join us for our monthly book club discussion of 'The Midnight Library' by Matt Haig. We'll explore themes of choices, regret, and the infinite possibilities of life.",
		date: today,
		endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 20, 0), // Today at 8 PM
		location: "City Library - Reading Room",
		address: "123 Book Lane, Reading, CA",
		isPaid: false,
		ticketsRemaining: 15,
		coverImage: "https://picsum.photos/800/400",
		organizer: {
			name: "Sarah Chen",
			avatar: "https://i.pravatar.cc/150?img=5",
		},
		schedule: [
			{ time: "6:30 PM", activity: "Welcome & Refreshments" },
			{ time: "7:00 PM", activity: "Book Discussion" },
			{ time: "8:00 PM", activity: "Next Month's Book Selection" },
			{ time: "8:30 PM", activity: "Social & Networking" },
		],
		tags: ["Fiction", "Book Discussion", "Monthly Meeting"],
		attendees: [
			{ id: 1, name: "Alex Kim", avatar: "https://i.pravatar.cc/150?img=11" },
			{ id: 2, name: "Maria Garcia", avatar: "https://i.pravatar.cc/150?img=12" },
			{ id: 3, name: "James Wilson", avatar: "https://i.pravatar.cc/150?img=13" },
			{ id: 4, name: "Emma Thompson", avatar: "https://i.pravatar.cc/150?img=14" },
			{ id: 5, name: "David Lee", avatar: "https://i.pravatar.cc/150?img=15" },
		],
	},
	{
		id: 2,
		title: "Author Meet & Greet: Mystery Writing Workshop",
		description: "Special workshop with mystery author Jane Smith. Learn about crafting compelling mysteries, developing characters, and plotting twists that keep readers guessing.",
		date: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2), // 2 days from now
		endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2, 16, 0), // Same day at 4 PM
		location: "Local Bookstore Cafe",
		address: "456 Literary Ave, Reading, CA",
		isPaid: true,
		price: 25.0,
		ticketsRemaining: 20,
		coverImage: "https://picsum.photos/800/400?random=2",
		organizer: {
			name: "Mike Johnson",
			avatar: "https://i.pravatar.cc/150?img=3",
		},
		schedule: [
			{ time: "2:00 PM", activity: "Workshop: Mystery Writing Basics" },
			{ time: "3:00 PM", activity: "Interactive Writing Exercise" },
			{ time: "3:45 PM", activity: "Q&A Session" },
			{ time: "4:15 PM", activity: "Book Signing" },
		],
		tags: ["Workshop", "Mystery", "Writing", "Author Event"],
		attendees: [
			{ id: 6, name: "Sophie Chen", avatar: "https://i.pravatar.cc/150?img=16" },
			{ id: 7, name: "Marcus Brown", avatar: "https://i.pravatar.cc/150?img=17" },
			{ id: 8, name: "Olivia Davis", avatar: "https://i.pravatar.cc/150?img=18" },
		],
	},
	{
		id: 3,
		title: "Children's Reading Circle: Fantasy Adventures",
		description: "A magical afternoon of storytelling and activities centered around classic fantasy books. Perfect for young readers aged 7-12.",
		date: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7), // 7 days from now
		endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7, 15, 0), // Same day at 3 PM
		location: "Kids Corner Bookstore",
		address: "789 Storybook Street, Reading, CA",
		isPaid: false,
		ticketsRemaining: 15,
		coverImage: "https://picsum.photos/800/400?random=3",
		organizer: {
			name: "Emily Watson",
			avatar: "https://i.pravatar.cc/150?img=4",
		},
		schedule: [
			{ time: "1:00 PM", activity: "Welcome & Introduction" },
			{ time: "1:30 PM", activity: "Storytime: Fantasy Classics" },
			{ time: "2:15 PM", activity: "Creative Writing Activity" },
			{ time: "2:45 PM", activity: "Character Drawing Session" },
			{ time: "3:15 PM", activity: "Parent-Child Reading Time" },
		],
		tags: ["Children", "Fantasy", "Reading Circle", "Family Event"],
		attendees: [
			{ id: 9, name: "Lisa Park", avatar: "https://i.pravatar.cc/150?img=19" },
			{ id: 10, name: "Tom Anderson", avatar: "https://i.pravatar.cc/150?img=20" },
			{ id: 11, name: "Rachel Green", avatar: "https://i.pravatar.cc/150?img=21" },
			{ id: 12, name: "Kevin Martinez", avatar: "https://i.pravatar.cc/150?img=22" },
			{ id: 13, name: "Anna White", avatar: "https://i.pravatar.cc/150?img=23" },
			{ id: 14, name: "Chris Taylor", avatar: "https://i.pravatar.cc/150?img=24" },
		],
	},
	{
		id: 4,
		title: "Classic Literature Book Exchange",
		description: "Bring your gently used classics and exchange them with other literature lovers. Special focus on 19th century novels.",
		date: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14), // 14 days from now
		endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14, 17, 0), // Same day at 5 PM
		location: "Vintage Books & Coffee",
		address: "101 Classic Court, Reading, CA",
		isPaid: false,
		ticketsRemaining: 30,
		coverImage: "https://picsum.photos/800/400?random=4",
		organizer: {
			name: "Robert Clark",
			avatar: "https://i.pravatar.cc/150?img=8",
		},
		schedule: [
			{ time: "2:00 PM", activity: "Book Check-in & Browsing" },
			{ time: "3:00 PM", activity: "Classic Literature Trivia" },
			{ time: "4:00 PM", activity: "Book Exchange Session" },
			{ time: "4:30 PM", activity: "Tea & Discussion" },
		],
		tags: ["Classics", "Book Exchange", "Literature", "Social"],
		attendees: [
			{ id: 15, name: "Diana Miller", avatar: "https://i.pravatar.cc/150?img=25" },
			{ id: 16, name: "John Smith", avatar: "https://i.pravatar.cc/150?img=26" },
			{ id: 17, name: "Sarah Johnson", avatar: "https://i.pravatar.cc/150?img=27" },
			{ id: 18, name: "Michael Wong", avatar: "https://i.pravatar.cc/150?img=28" },
		],
	},
];

export const EventsPageType = {
	...BasePageType,
	component: EventsPage,
	icon: "calendar-outline",
	title: "Events",
	getDefaultContent: () => ({
		events: defaultEvents,
	}),
};

export default EventsPageType;
